import { render, staticRenderFns } from "./WalletRolesList.vue?vue&type=template&id=2e6c2110&"
import script from "./WalletRolesList.vue?vue&type=script&lang=js&"
export * from "./WalletRolesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports